import Alert from '@mui/material/Alert';
import DatePicker from './DatePicker';
import Markdown from 'react-markdown'
import React from 'react';

const LocationHeader = (props) => {
  const {children, imageUrl, menuNotes} = props;
  // console.log(menuNotes);
  let image = imageUrl !== undefined ? 'url(' + imageUrl + ')' : 'url(../images/onebowl.png)';
  return <div className="location-header location-image" key="location-header" style={{ backgroundImage: image}}>
    <div className="location-header-title">
      <div className="location-header-title-text">Menu</div>
      <DatePicker
        {...props}
      />
    </div>
    <div className="spacer">
    <Alert variant="filled" className="c-menu-notes" severity="info" sx={{
      zIndex: 0,
      position: 'relative',
      margin: '0 5rem'
    }}>
      <Markdown>{menuNotes}</Markdown>
    </Alert>
    </div>

    
    {children}
  </div>
}

export default LocationHeader;